/* istanbul ignore file */
import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import SahamDrawer from 'components/SahamDrawer';
import { translate, arrayTranslate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import {
  Container,
  StyledSelect,
  GridWrapper,
} from 'containers/TransactionManagerTimeLine/styles';
import {
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  FormHelperText,
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
  Select,
  Grid,
} from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import hash from 'object-hash';

import DateFnsUtils from '@date-io/date-fns';
import {
  CLAIM,
  EMPTY_VICTIM,
  INCOME_CERTIFICATE,
  TUTOR,
  VICTIM,
} from 'containers/data-structure';
import { isMinorVictim } from 'containers/PreOpeningPage/utils';
import { DOCUMENT_TYPES } from 'constants/global';
import {
  BeneficiaryType,
  TransactionDocumentType,
  TransactionType,
} from 'typings/globalTypes';
import { isEmpty, get, uniqueId, isNil, find } from 'lodash';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import moment from 'moment-timezone';
import frLocale from 'date-fns/locale/fr';
import {
  INJURY_POST,
  CHOICES,
  GENDER,
  MINOR_VALUE,
} from 'containers/PreOpeningPage/constants';
import { displayErrorText } from 'containers/services/validateForm';
import { formsAreValidated } from 'containers/services/validateForm';
import { getMoroccanCities, getCity } from 'containers/RecapManagerPage/utils';
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { VICTIM_QUALITY_KEYS } from 'containers/CourtManagerLegalProceedings/constants';
import { filterVisibleOnly } from 'containers/services/filters';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { displayErrorInputCin } from 'containers/RecapManagerPage/utils';
import InputMask from 'react-input-mask';
import { Autocomplete as AutoComplete } from '@material-ui/lab';
import {
  getClaimInfoSagis,
  isOtherProfession,
} from 'containers/CourtManagerLegalProceedings/utils';
import {
  MANAGEMENT_MODES,
  OTHER_PROFESSION,
  SCALE_CASES_KEY,
} from 'containers/RecapManagerPage/constants';
import BeneficiaryForm from 'containers/PreOpeningPage/BeneficiaryForm';
import { VICTIM_ITT_AVAILABILITY } from 'containers/PreOpeningPage/constants';
import {
  checkClassVictim,
  checkVictimAge,
} from 'containers/PreOpeningPage/utils';
import UploadDocument from 'containers/common/UploadDocument';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import {
  getDocumentsByType,
  isAssignedArea,
  isPrimaryButtonAddTransactionDisabled,
  updateAfterValidation,
  isPrimaryButtonUpdateTransactionDisabled,
  contactVictims,
  getDocumentWithoutType,
} from 'containers/TransactionManagerTimeLine/utils';

import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  formatPayloadToUpdate,
  formatPayloadToInsert,
} from 'containers/TransactionManagerTimeLine/utils';
import { formatVictims } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/utils';
import { PROFESSION_CODES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import {
  removeDeletedItems,
  displayVehiclePassenger,
  formatTitleDocument,
  addPriorityReasonProfession,
  removeRejectedVictims,
  updateItemInList,
} from 'services/utils';
import { DATE_FORMAT } from 'constants/global';
import {
  claimCircumstancesValidator,
  victimValidator,
} from 'containers/TransactionManagerTimeLine/constraints';
import { THIRD_VALIDATION_INBOXE_TITLE } from 'containers/TransactionManagerTimeLine/constants';
import { lastEvaluationOfOtherVictims } from 'containers/TransactionManagerTimeLine/DecisionDialog/utils';
import {
  getProposedIncomeByProfession,
  getTheLatestEvaluationObject,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/IncomeCertificate/utils';

export interface AddTransactionDrawerProps {
  intl: IntlShape;
  open: boolean;
  listings: Listings;
  handleToggleDrawer: Function;
  index: number;
  data: any;
  policyInfo: any;
  dataClaimToUpdate?: any;
  inputLabelProps?: boolean;
  resetUploadedDocument?: Function;
  uploadedDocument?: any;
  uploadDocument?: Function;
  requestAddTransaction?: Function;
  isUpdate?: boolean;
  transactionDocuments?: TransactionDocumentType[];
  requestUpdateTransaction?: Function;
  victimInfo?: any;
  transactionId?: any;
  requestGetTransaction?: Function;
  claimId?: any;
  scaleCaseInfo?: any;
  claimNumber?: any;
  riskKey?: any;
  victimValidation: any;
  setVictimValidation: Function;
  claimVictims: any;
  receptionDate: Date;
  transactionInfo: TransactionType;
  dahirAmounts: any;
}

const AddTransactionDrawer: React.FC<AddTransactionDrawerProps> = (
  props,
): JSX.Element => {
  const [isScaleCaseOther, updateIsScaleCaseOther] = React.useState(false);
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [documentType, setDocumentType] = React.useState<any>(null);
  const [income, setIncome] = React.useState<any>(null);
  const victim = get(props.data, `victims[${props.index}]`);
  useEffect(() => {
    const proposedIncome = getProposedIncomeByProfession(
      get(props.listings, 'allocationConfig', []),
      victim,
      moment(get(props.data, 'claim.lossDate')).format('YYYY-MM-DD') as any,
    );
    if (
      !isNil(proposedIncome) &&
      documentType === DOCUMENT_TYPES.SCHOOLING_CERTIFICATE
    ) {
      setIncome(proposedIncome);
    }
  }, [victim.professionCode, documentType]);
  const [transactionDocuments, setTransactionDocuments] = React.useState<
    TransactionDocumentType[]
  >([]);
  let [data, setData] = React.useState<any>({});
  let [scaleInfo, setScaleInfo] = React.useState<any>({});
  const [receptionDate, setReceptionDate] = React.useState(null);
  const [tutorInfo, setTutorInfo] = React.useState<any>({});
  const [beneficiaries, setBeneficiaries] = React.useState<BeneficiaryType[]>(
    [],
  );
  const [victimValidation, setVictimValidation] = React.useState({});
  React.useEffect(() => {
    setScaleInfo({
      ...props.scaleCaseInfo,
    });
    setData({
      ...props.data,
      victims: removeDeletedItems(get(props.data, 'victims', [])),
      deletedVictims: get(props.data, 'victims', []).filter(
        (el: any) => el.isDeleted,
      ),
    });
    setBeneficiaries(get(get(props.data, 'victims', []), 'beneficiaries', []));
    if (props.isUpdate) {
      setTutorInfo(get(props.transactionInfo, 'tutorInfo', {}));
      setTransactionDocuments(
        (props.transactionDocuments as unknown) as TransactionDocumentType[],
      );
      setDocumentType(null);
      if (props.receptionDate) {
        setReceptionDate(props.receptionDate as any);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.transactionInfo,
    props.receptionDate,
    props.scaleCaseInfo,
    props.transactionDocuments,
  ]);
  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const receiptDate = moment(theDate as Date).format(DATE_FORMAT);
    setReceptionDate(receiptDate as any);
  };
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;
    const index = props.index;
    const { victims } = data;

    switch (field) {
      case VICTIM.CIN:
        victims[index][VICTIM.CIN] = value;
        break;
      case VICTIM.LAST_NAME:
        victims[index][VICTIM.LAST_NAME] = value;
        break;
      case VICTIM.FIRST_NAME:
        victims[index][VICTIM.FIRST_NAME] = value;
        break;
      case VICTIM.TELEPHONE_NUMBER:
        victims[index][VICTIM.TELEPHONE_NUMBER] = value.replace(/\s+/g, '');
        break;
      case VICTIM.PROCEDURE_ID:
        victims[index][VICTIM.PROCEDURE_ID] = value;
        break;
      case VICTIM.DAMAGE_TYPE:
        victims[index][VICTIM.DAMAGE_TYPE] = value;
        break;
      case VICTIM.PROFESSION:
        victims[index][VICTIM.PROFESSION] = value;
        break;
      case VICTIM.PROFESSION_TYPE:
        victims[index][VICTIM.PROFESSION_TYPE] = get(valueField, 'ItemKey');
        victims[index][VICTIM.PROFESSION] =
          get(valueField, 'ItemKey') === OTHER_PROFESSION
            ? victims[index][VICTIM.PROFESSION]
            : null;
        break;
      case VICTIM.WORK_ACCIDENT_ID:
        victims[index][VICTIM.WORK_ACCIDENT_ID] = value;
        break;
      case VICTIM.CLASS_KEY:
        victims[index][VICTIM.CLASS_KEY] = value;
        if (value === MINOR_VALUE) {
          victims[index][VICTIM.NUMBER_OF_SPOUSE] = 0;
          victims[index][VICTIM.NUMBER_OF_DEPENDENTS] = 0;
          victims[index][VICTIM.NUMBER_OF_CHILDREN] = 0;
        }
        break;
      case VICTIM.ITT_AVAILABILITY:
        victims[index][VICTIM.ITT_AVAILABILITY] = value;
        victims[index][VICTIM.ITT] =
          String(value) === VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE
            ? ''
            : victims[index][VICTIM.ITT];
        break;
      case VICTIM.ITT:
        victims[index][VICTIM.ITT] =
          typeof value === 'string' ? value.replace(/[^0-9]/g, '') : value;
        break;
      case VICTIM.CITY:
        victims[index][VICTIM.CITY] = get(valueField, 'ItemKey');
        break;
      case VICTIM.ADDRESS:
        victims[index][VICTIM.ADDRESS] = value;
        break;
      case VICTIM.IS_EXCLUDED:
        victims[index][VICTIM.IS_EXCLUDED] = value === 'true' ? true : false;
        break;
      case VICTIM.INJURY_POST_KEY:
        victims[index][VICTIM.INJURY_POST_KEY] = value;
        break;
      case VICTIM.QUALITY_KEY:
        victims[index][VICTIM.QUALITY_KEY] = value;
        if (
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE)
        ) {
          victims[index][VICTIM.IS_EXCLUDED] =
            value === VICTIM_QUALITY_KEYS.Driver ||
            value === VICTIM_QUALITY_KEYS.Subscriber
              ? true
              : EMPTY_VICTIM[VICTIM.IS_EXCLUDED];
        }
        break;
      case VICTIM.VEHICLE_PASSENGER_ID:
        victims[index][VICTIM.VEHICLE_PASSENGER_ID] = value;
        break;
      case VICTIM.OPPOSITION:
        victims[index][VICTIM.OPPOSITION] = !!(value === 1);
        break;
      case VICTIM.GENDER:
        victims[index][VICTIM.GENDER] = value;
        break;
      case VICTIM.NUMBER_OF_SPOUSE:
        victims[index][VICTIM.NUMBER_OF_SPOUSE] = Number(value);
        break;
      case VICTIM.NUMBER_OF_DEPENDENTS:
        victims[index][VICTIM.NUMBER_OF_DEPENDENTS] = Number(value);
        break;
      case VICTIM.NUMBER_OF_CHILDREN:
        victims[index][VICTIM.NUMBER_OF_CHILDREN] = Number(value);
        break;
      case VICTIM.ANNUAL_INCOME:
        victims[index][VICTIM.ANNUAL_INCOME] =
          typeof value === 'string' ? value.replace(',', '.') : value;
        break;
      default:
        return victims;
    }

    setData({ ...data, victims });
  };
  const handleChangeTutorInfo = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;
    tutorInfo[field] = value;
    setTutorInfo({ ...tutorInfo });
  };
  const getCircumstances = () => {
    let circumstances = get(props.listings, 'circumstance', []).filter(
      (circumstance: SagisConfig) =>
        circumstance.ItemGroup === scaleInfo[CLAIM.SCALE_CASE_KEY],
    );
    return circumstances;
  };
  const handleChangeScaleCase = (field: string) => (
    event: React.ChangeEvent<{ name?: string; value: any }>,
  ) => {
    const { value } = event.target;
    switch (field) {
      case CLAIM.SCALE_CASE_KEY:
        scaleInfo[CLAIM.ACCIDENT_CIRCONSTANCE_KEY] = '';
        scaleInfo[CLAIM.ACCIDENT_CIRCONSTANCE] = '';
        scaleInfo[CLAIM.RESPONSABILITY_KEY] = '';
        scaleInfo[CLAIM.RESPONSABILITY_SHARE] = '';
        scaleInfo[CLAIM.SCALE_CASE_KEY] = value;
        if (value === SCALE_CASES_KEY.OTHER) {
          updateIsScaleCaseOther(true);
        } else {
          updateIsScaleCaseOther(false);
        }
        break;
      case CLAIM.ACCIDENT_CIRCONSTANCE_KEY: {
        scaleInfo[CLAIM.ACCIDENT_CIRCONSTANCE] = '';
        scaleInfo[CLAIM.RESPONSABILITY_KEY] = '';
        scaleInfo[CLAIM.RESPONSABILITY_SHARE] = '';
        scaleInfo[CLAIM.ACCIDENT_CIRCONSTANCE_KEY] = value;
        const expectedCircumstance = get(
          props.listings,
          'circumstance',
          [],
        ).find((circumstance: SagisConfig) => circumstance.ItemKey === value);

        scaleInfo[CLAIM.RESPONSABILITY_KEY] = expectedCircumstance
          ? expectedCircumstance.responsablityRateCode
          : '';
        if (isScaleCaseOther) {
          scaleInfo[CLAIM.ACCIDENT_CIRCONSTANCE] = expectedCircumstance
            ? expectedCircumstance.ItemDescription
            : '';
        }
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === scaleInfo[CLAIM.RESPONSABILITY_KEY],
        );
        scaleInfo[CLAIM.RESPONSABILITY_SHARE] = get(
          responsability,
          'ItemDescription',
          '',
        );
        break;
      }

      case CLAIM.RESPONSABILITY_KEY:
        scaleInfo[CLAIM.RESPONSABILITY_KEY] = value;
        const responsability = find(
          get(props.listings, 'responsability'),
          (element: { ItemKey: any }) =>
            element.ItemKey === scaleInfo[CLAIM.RESPONSABILITY_KEY],
        );
        scaleInfo[CLAIM.RESPONSABILITY_SHARE] = get(
          responsability,
          'ItemDescription',
          '',
        );
        break;
      case CLAIM.ACCIDENT_DESCRIPTION:
        scaleInfo[CLAIM.ACCIDENT_DESCRIPTION] = value;
        break;
      case CLAIM.MANAGEMENT_MODE:
        scaleInfo[CLAIM.MANAGEMENT_MODE] = value;
        break;
      default:
        return scaleInfo;
    }
    setScaleInfo({ ...scaleInfo });
  };

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const { victims } = data;
    victims[props.index][VICTIM.DATE_OF_BIRTH] = moment(
      theDate as Date,
    ).format();

    setData({ ...data, victims });

    return;
  };
  const handleChangeIncome = (event: any) => {
    setIncome(event.target.value);
  };

  const handleChangeDocumentType = (event: any) => {
    if (!isNil(documentType)) {
      addTransactionDocument(event.target.value);
    }
    setDocumentType(event.target.value);
  };
  const handleChangeDocument = (name: string) => (
    document: TransactionDocumentType,
  ) => {
    const filtredDoc = transactionDocuments.filter(
      (el: any) =>
        el?.name != name &&
        (!isNil(get(el, 'content', null)) ||
          !isNil(get(el, 'documentumId', null))),
    );
    const transactionDocumentTypeId = get(
      get(props.listings, 'transactionDocumentTypes', []).find(
        (el: any) => el.title === documentType,
      ),
      'id',
    );
    setTransactionDocuments([
      ...filtredDoc,
      {
        //to-update sagisDocType
        ...document,
        transactionDocumentTypeId: transactionDocumentTypeId,
        name: name,
        sagisType:
          documentType === DOCUMENT_TYPES.INCOME_CERTIFICATE
            ? 'Attestation de Revenu'
            : 'Etude PV (Transaction)',
      },
    ]);
  };
  const addTransactionDocument = (type: string) => {
    setTransactionDocuments(([
      ...transactionDocuments.filter(
        (el: any) => !isNil(el.content) || !isNil(el.documentumId),
      ),
      { type: type, content: null },
    ] as unknown) as TransactionDocumentType[]);
  };
  const successCallBack = () => {
    toast.success(translate(messages.successToastAddTransaction, props));
    props.handleToggleDrawer();
    if (props.claimId && props.requestGetTransaction) {
      props.requestGetTransaction({ claimId: props.claimId });
    }
  };

  const successCallBackUpdate = () => {
    toast.success(translate(messages.successUpdateTransaction, props));
    props.handleToggleDrawer();
    if (props.claimId && props.requestGetTransaction) {
      props.requestGetTransaction({ claimId: props.claimId });
    }
  };
  const validator =
    { ...victimValidator(victim), ...claimCircumstancesValidator(scaleInfo) } ||
    {};
  const claimCircumstancesValidation =
    claimCircumstancesValidator(scaleInfo) || {};

  const handleCreateTransaction = (
    priorityReasonId: any,
    claimResponsabilityRate: any,
  ) => {
    if (props.requestAddTransaction) {
      const formattedVictims = formatVictims(
        [{ ...victim, annualOfIncome: !isNil(income) ? income : undefined }],
        claimResponsabilityRate,
        props.listings,
      );
      const corpoVictim = {
        ...victim,
        claimId: props.claimId,
        annualOfIncome: !isNil(income) ? income : undefined,
      };
      props.requestAddTransaction(
        formatPayloadToInsert(
          corpoVictim,
          props.victimInfo,
          transactionDocuments,
          scaleInfo,
          formattedVictims,
          props.claimNumber,
          props.riskKey,
          priorityReasonId,
          receptionDate,
          tutorInfo,
          beneficiaries,
        ),
        successCallBack,
      );
    }
  };

  const validatorUpdate =
    {
      ...victimValidator(victim),
      ...claimCircumstancesValidator(scaleInfo),
    } || {};

  const handleValidation = () => {
    const claimResponsabilityRate = getClaimInfoSagis(props.policyInfo)
      ?.responsibilityRate;
    const priorityReasonClaimId = get(
      props.data,
      'claim.priorityReasonId',
      null,
    );
    const priorityReasonId = addPriorityReasonProfession(
      priorityReasonClaimId,
      !!removeRejectedVictims(
        contactVictims(props.claimVictims, victim),
      ).find((v: any) => PROFESSION_CODES.includes(v.professionCode)),
      props.listings,
    )
      ? addPriorityReasonProfession(
          priorityReasonClaimId,
          !!removeRejectedVictims(
            contactVictims(props.claimVictims, victim),
          ).find((v: any) => PROFESSION_CODES.includes(v.professionCode)),
          props.listings,
        )
      : addPriorityReasonProfession(
          priorityReasonClaimId,
          !!PROFESSION_CODES.includes(victim.professionCode),
          props.listings,
        )
      ? addPriorityReasonProfession(
          priorityReasonClaimId,
          !!PROFESSION_CODES.includes(victim.professionCode),
          props.listings,
        )
      : undefined;
    setVictimValidation(validator);

    if (
      formsAreValidated(validator) &&
      !displayErrorInputCin(data, victim, props.dataClaimToUpdate) &&
      props.requestAddTransaction &&
      !props.isUpdate
    ) {
      handleCreateTransaction(priorityReasonId, claimResponsabilityRate);
    } else if (
      formsAreValidated(validatorUpdate) &&
      !displayErrorInputCin(data, victim, {
        ...props.dataClaimToUpdate,
        victims: props.claimVictims,
      }) &&
      props.isUpdate &&
      props.requestUpdateTransaction &&
      props.victimInfo &&
      props.transactionId &&
      props.scaleCaseInfo
    ) {
      const lastEvaluationOfOtherVictim = lastEvaluationOfOtherVictims(
        props.claimVictims?.filter(
          (item: any) => item.victimKey != victim.victimKey,
        ),
        props.dahirAmounts,
      );
      const lastEvaluation = getTheLatestEvaluationObject(
        victim.victimKey,
        props.dahirAmounts,
      );
      const oldInfo = props.claimVictims.find((el: any) => el.id === victim.id);
      const formatBody = formatPayloadToUpdate(
        { ...victim, annualOfIncome: !isNil(income) ? income : undefined },
        oldInfo,
        transactionDocuments,
        props.transactionDocuments,
        {
          ...props.scaleCaseInfo,
        },
        {
          ...scaleInfo,
        },
        updateAfterValidation(get(props.transactionInfo, 'timeLine', [])) &&
          isAssignedArea(
            props.transactionInfo,
            props.listings,
            THIRD_VALIDATION_INBOXE_TITLE,
          ),
        props.claimVictims,
        { ...props.transactionInfo, receptionDate },
        get(props.data, 'claim'),
        lastEvaluation,
        lastEvaluationOfOtherVictim,
        formatVictims(
          [{ ...victim, annualOfIncome: !isNil(income) ? income : undefined }],
          claimResponsabilityRate,
          props.listings,
        ),
        beneficiaries,
        tutorInfo,
        get(props.transactionInfo, 'tutorInfo', []),
        props.riskKey,
        priorityReasonId,
      );
      props.requestUpdateTransaction(
        {
          ...formatBody,
          claimNumber: props.claimNumber,
          riskKey: props.riskKey,
          claimId: Number(props.claimId),
          transactionId: props.transactionId,
          username: currentUserStorage.get()?.username,
        },
        successCallBackUpdate,
      );
    }
  };

  const handleDeleteDocument = (element: any) => {
    const filtredDoc = transactionDocuments.filter(
      (el: any) => el.id != element.id,
    );
    setTransactionDocuments([...filtredDoc]);
  };

  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const { message } = displayErrorText(
    { ...victimValidation, ...claimCircumstancesValidation },
    translateArrayErrorMessages(
      { ...victimValidation, ...claimCircumstancesValidation },
      true,
    ),
  );

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) =>
      option?.ItemDescription ? option?.ItemDescription : '',
  });
  return (
    <SahamDrawer
      open={props.open}
      handleToggleDrawer={() => props.handleToggleDrawer(null, true)}
      title={
        props.isUpdate
          ? translate(messages.updateTransactionDrawer, props)
          : translate(messages.titleDrawerTransaction, props)
      }
      handleClickPrimaryButton={handleValidation}
      primaryButtonTitle={translate(messages.confirmButtonTitle, props)}
      isPrimaryButtonDisabled={
        props.isUpdate
          ? isPrimaryButtonUpdateTransactionDisabled(
              props,
              victim,
              transactionDocuments,
              receptionDate,
              income,
            )
          : isPrimaryButtonAddTransactionDisabled(
              props,
              victim,
              transactionDocuments,
              receptionDate,
              income,
            )
      }
    >
      <Container>
        <Typography className="subTitle">
          {translate({ ...messages.infoVictimTitle }, props)}
        </Typography>
        <TextField
          label={translate({ ...messages.victimCin }, props)}
          className="input"
          name={VICTIM.CIN}
          value={get(victim, [VICTIM.CIN])}
          onChange={handleChange(VICTIM.CIN)}
          InputProps={{ inputProps: { maxlength: 20 } }}
          error={
            !!get(victimValidation, [VICTIM.CIN]) ||
            displayErrorInputCin(data, victim, props.dataClaimToUpdate)
          }
          helperText={
            displayErrorInputCin(data, victim, props.dataClaimToUpdate)
              ? translate(messages.errorCinVictim, props)
              : message[VICTIM.CIN]
          }
        />
        <TextField
          label={translate({ ...messages.victimLastName }, props)}
          className="input"
          name={VICTIM.LAST_NAME}
          value={get(victim, [VICTIM.LAST_NAME])}
          onChange={handleChange(VICTIM.LAST_NAME)}
          error={!!get(victimValidation, [VICTIM.LAST_NAME])}
          helperText={message[VICTIM.LAST_NAME]}
        />
        <TextField
          label={translate({ ...messages.victimFirstName }, props)}
          className="input"
          name={VICTIM.FIRST_NAME}
          value={get(victim, [VICTIM.FIRST_NAME])}
          onChange={handleChange(VICTIM.FIRST_NAME)}
          error={!!get(victimValidation, [VICTIM.FIRST_NAME])}
          helperText={message[VICTIM.FIRST_NAME]}
        />
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            invalidDateMessage={
              !!get(victimValidation, [VICTIM.DATE_OF_BIRTH])
                ? message[VICTIM.DATE_OF_BIRTH]
                : ''
            }
            format="dd/MM/yyyy"
            id="date-picker-inline-victim-date-of-birth"
            label={translate({ ...messages.victimDateOfBirth }, props)}
            className="input"
            name={VICTIM.DATE_OF_BIRTH}
            value={dateStringToLocalDate(
              get(victim, [VICTIM.DATE_OF_BIRTH], ''),
            )}
            onChange={handleDateChange}
            error={
              dateStringToLocalDate(get(victim, [VICTIM.DATE_OF_BIRTH], '')) ===
                'Invalid date' ||
              checkVictimAge(
                get(victim, [VICTIM.DATE_OF_BIRTH]),
                get(props.data, 'claim.lossDate'),
              )
            }
            helperText={
              dateStringToLocalDate(get(victim, [VICTIM.DATE_OF_BIRTH], '')) ===
              'Invalid date'
                ? translate(messages.invalidDate, props)
                : checkVictimAge(
                    get(victim, [VICTIM.DATE_OF_BIRTH]),
                    get(props.data, 'claim.lossDate'),
                  )
                ? translate(messages.birthDateValidation, props)
                : translate(messages.invalidDate, props)
            }
          />
        </MuiPickersUtilsProvider>
        <FormControl
          className="input"
          error={!!get(victimValidation, [VICTIM.GENDER])}
        >
          <InputLabel
            ref={inputLabel}
            id="simple-select-outlined-label-work-accident"
          >
            {translate({ ...messages.sexe }, props)}
          </InputLabel>
          <Select
            name={VICTIM.GENDER}
            value={get(victim, [VICTIM.GENDER], '')}
            onChange={handleChange(VICTIM.GENDER)}
            labelWidth={230}
          >
            <MenuItem value={GENDER.MALE} key={0}>
              {GENDER.MALE}
            </MenuItem>
            <MenuItem value={GENDER.FEMALE} key={1}>
              {GENDER.FEMALE}
            </MenuItem>
          </Select>
        </FormControl>
        {!!get(props.victimValidation, [VICTIM.GENDER]) && (
          <FormHelperText className="errorSelect">
            {message[VICTIM.GENDER]}
          </FormHelperText>
        )}
        <InputMask
          mask="9999 999 999"
          value={get(victim, [VICTIM.TELEPHONE_NUMBER])}
          onChange={handleChange(VICTIM.TELEPHONE_NUMBER)}
        >
          {() => (
            <TextField
              label={translate({ ...messages.victimTelephone }, props)}
              className="input"
              error={!!get(victimValidation, [VICTIM.TELEPHONE_NUMBER])}
              helperText={message[VICTIM.TELEPHONE_NUMBER]}
            ></TextField>
          )}
        </InputMask>
        <FormControl
          className="input"
          error={!!get(victimValidation, [VICTIM.QUALITY_KEY])}
        >
          <InputLabel
            ref={inputLabel}
            id="simple-select-outlined-label-procedure"
          >
            {translate({ ...messages.victimQualityKey }, props)}
          </InputLabel>
          <Select
            name={VICTIM.QUALITY_KEY}
            value={get(victim, [VICTIM.QUALITY_KEY], '')}
            onChange={handleChange(VICTIM.QUALITY_KEY)}
          >
            {!isEmpty(get(props.listings, 'qualityOfVictim', [])) &&
              props.listings!.qualityOfVictim.map(classItem => (
                <MenuItem value={classItem.ItemKey} key={classItem.ItemKey}>
                  {classItem.ItemDescription}
                </MenuItem>
              ))}
          </Select>
          {!!get(victimValidation, [VICTIM.QUALITY_KEY]) && (
            <FormHelperText className="errorSelect">
              {message[VICTIM.QUALITY_KEY]}
            </FormHelperText>
          )}
        </FormControl>
        {displayVehiclePassenger(victim) && (
          <FormControl
            className="input"
            error={!!get(victimValidation, [VICTIM.VEHICLE_PASSENGER_ID])}
          >
            <InputLabel
              ref={inputLabel}
              id="simple-select-outlined-label-procedure"
            >
              {translate({ ...messages.vehiclePassenger }, props)}
            </InputLabel>
            <Select
              name={VICTIM.VEHICLE_PASSENGER_ID}
              value={get(victim, [VICTIM.VEHICLE_PASSENGER_ID], '')}
              onChange={handleChange(VICTIM.VEHICLE_PASSENGER_ID)}
            >
              {get(props.listings, 'vehiclePassenger', []).map(
                (classItem: any) => (
                  <MenuItem value={classItem.id} key={classItem.id}>
                    {classItem.title}
                  </MenuItem>
                ),
              )}
            </Select>
            {!!get(victimValidation, [VICTIM.VEHICLE_PASSENGER_ID]) && (
              <FormHelperText className="errorSelect">
                {message[VICTIM.VEHICLE_PASSENGER_ID]}
              </FormHelperText>
            )}
          </FormControl>
        )}

        {!props.isUpdate && (
          <FormControl
            className="input"
            error={!!get(victimValidation, [VICTIM.INJURY_POST_KEY])}
          >
            <InputLabel
              ref={inputLabel}
              id="simple-select-outlined-label-procedure"
            >
              {translate({ ...messages.victimInjuryPostKey }, props)}
            </InputLabel>
            <Select
              name={VICTIM.INJURY_POST_KEY}
              value={
                get(victim, [VICTIM.INJURY_POST_KEY], '') ===
                INJURY_POST.INJURED[1]
                  ? INJURY_POST.INJURED[0]
                  : get(victim, [VICTIM.INJURY_POST_KEY], '')
              }
              onChange={handleChange(VICTIM.INJURY_POST_KEY)}
              labelWidth={230}
            >
              {!isEmpty(get(props.listings, 'prejudice', [])) &&
                props
                  .listings!.prejudice.filter(
                    (el: any) => el.ItemKey !== INJURY_POST.INJURED[1],
                  )
                  .map(e => (
                    <MenuItem value={e.ItemKey} key={e.ItemKey}>
                      {get(e.ItemDescription.split(' '), '[0]', '')}
                    </MenuItem>
                  ))}
            </Select>
            {!!get(victimValidation, [VICTIM.INJURY_POST_KEY]) && (
              <FormHelperText className="errorSelect">
                {message[VICTIM.INJURY_POST_KEY]}
              </FormHelperText>
            )}
          </FormControl>
        )}

        <FormControl
          className="input"
          error={
            !!get(victimValidation, [VICTIM.CLASS_KEY]) ||
            checkClassVictim(
              get(victim, [VICTIM.DATE_OF_BIRTH]),
              get(props.data, 'claim.lossDate'),
              get(victim, [VICTIM.CLASS_KEY]),
            )
          }
        >
          <InputLabel ref={inputLabel} id="simple-select-outlined-label-class">
            {translate({ ...messages.class }, props)}
          </InputLabel>
          <Select
            name={VICTIM.CLASS_KEY}
            value={get(victim, [VICTIM.CLASS_KEY], '')}
            onChange={handleChange(VICTIM.CLASS_KEY)}
            labelWidth={140}
          >
            {!isEmpty(get(props.listings, 'classVictim', [])) &&
              props.listings!.classVictim.map(classItem => (
                <MenuItem value={classItem.ItemKey} key={classItem.ItemKey}>
                  {classItem.ItemDescription}
                </MenuItem>
              ))}
          </Select>
          {(!!get(victimValidation, [VICTIM.CLASS_KEY]) ||
            checkClassVictim(
              get(victim, [VICTIM.DATE_OF_BIRTH]),
              get(props.data, 'claim.lossDate'),
              get(victim, [VICTIM.CLASS_KEY]),
            )) && (
            <FormHelperText className="errorSelect">
              {checkClassVictim(
                get(victim, [VICTIM.DATE_OF_BIRTH]),
                get(props.data, 'claim.lossDate'),
                get(victim, [VICTIM.CLASS_KEY]),
              )
                ? translate(messages.classKeyValidation, props)
                : message[VICTIM.CLASS_KEY]}
            </FormHelperText>
          )}
        </FormControl>

        <FormControl
          className="input"
          error={!!get(victimValidation, [VICTIM.PROCEDURE_ID])}
        >
          <InputLabel
            ref={inputLabel}
            id="simple-select-outlined-label-procedure"
          >
            {translate({ ...messages.typeProcedure }, props)}
          </InputLabel>
          <Select
            name={VICTIM.PROCEDURE_ID}
            value={get(victim, [VICTIM.PROCEDURE_ID], '')}
            onChange={handleChange(VICTIM.PROCEDURE_ID)}
            labelWidth={230}
          >
            {!isEmpty(get(props.listings, 'procedures', [])) &&
              filterVisibleOnly(props.listings!.procedures).map(procedure => (
                <MenuItem value={procedure.id} key={procedure.id}>
                  {procedure.title}
                </MenuItem>
              ))}
          </Select>
          {!!get(victimValidation, [VICTIM.PROCEDURE_ID]) && (
            <FormHelperText className="errorSelect">
              {message[VICTIM.PROCEDURE_ID]}
            </FormHelperText>
          )}
        </FormControl>

        <FormControl className="input">
          <AutoComplete
            options={get(props.listings, 'Profession', [])}
            getOptionLabel={(option: any) =>
              `${option?.ItemDescription ? option?.ItemDescription : ''}`
            }
            value={
              (get(props.listings, 'Profession', []).find(
                (item: any) =>
                  item.ItemKey === get(victim, VICTIM.PROFESSION_TYPE),
              ) || {}) as any
            }
            onChange={handleChange(VICTIM.PROFESSION_TYPE)}
            renderInput={(params: any) => (
              <TextField
                {...params}
                variant="standard"
                label={translate(messages.professionType, props)}
                error={!!get(victimValidation, [VICTIM.PROFESSION_TYPE])}
                helperText={message[VICTIM.PROFESSION_TYPE]}
              />
            )}
          />
        </FormControl>
        {isOtherProfession(
          get(props.listings, 'Profession', []),
          get(victim, [VICTIM.PROFESSION_TYPE]),
        ) && (
          <TextField
            label={translate({ ...messages.profession }, props)}
            className="input"
            name={VICTIM.PROFESSION}
            value={get(victim, [VICTIM.PROFESSION])}
            onChange={handleChange(VICTIM.PROFESSION)}
            error={!!get(victimValidation, [VICTIM.PROFESSION])}
            helperText={message[VICTIM.PROFESSION]}
          />
        )}
        <FormControl
          className="input"
          error={!!get(victimValidation, [VICTIM.WORK_ACCIDENT_ID])}
        >
          <InputLabel
            ref={inputLabel}
            id="simple-select-outlined-label-work-accident"
          >
            {translate({ ...messages.workAccident }, props)}
          </InputLabel>
          <Select
            name={VICTIM.WORK_ACCIDENT_ID}
            value={get(victim, [VICTIM.WORK_ACCIDENT_ID], '')}
            onChange={handleChange(VICTIM.WORK_ACCIDENT_ID)}
            labelWidth={140}
          >
            {!isEmpty(get(props.listings, 'workAccidents', [])) &&
              props.listings!.workAccidents.map(type => (
                <MenuItem value={type.id} key={type.id}>
                  {type.title}
                </MenuItem>
              ))}
          </Select>
          {!!get(victimValidation, [VICTIM.WORK_ACCIDENT_ID]) && (
            <FormHelperText className="errorSelect">
              {message[VICTIM.WORK_ACCIDENT_ID]}
            </FormHelperText>
          )}
        </FormControl>
        {get(victim, [VICTIM.INJURY_POST_KEY], '') !== '' &&
          !INJURY_POST.DECEASED.includes(
            get(victim, [VICTIM.INJURY_POST_KEY], ''),
          ) && (
            <>
              <FormControl fullWidth className="input">
                <InputLabel ref={inputLabel}>
                  {translate({ ...messages.availabilityItt }, props)}
                </InputLabel>
                <StyledSelect
                  name={VICTIM.ITT_AVAILABILITY}
                  value={
                    !isNil(get(victim, [VICTIM.ITT], null)) &&
                    get(victim, [VICTIM.ITT]) !== ''
                      ? VICTIM_ITT_AVAILABILITY.AVAILABLE
                      : VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE
                  }
                  onChange={handleChange(VICTIM.ITT_AVAILABILITY)}
                >
                  <MenuItem
                    value={VICTIM_ITT_AVAILABILITY.AVAILABLE}
                    key={uniqueId()}
                  >
                    {translate({ ...messages.available }, props)}
                  </MenuItem>
                  <MenuItem
                    value={VICTIM_ITT_AVAILABILITY.NOT_AVAILABLE}
                    key={uniqueId()}
                  >
                    {translate({ ...messages.notAvailable }, props)}
                  </MenuItem>
                </StyledSelect>

                {!!get(victimValidation, [VICTIM.ITT_AVAILABILITY]) && (
                  <FormHelperText className="errorSelect">
                    {message[VICTIM.ITT_AVAILABILITY]}
                  </FormHelperText>
                )}
              </FormControl>

              {(get(victim, [VICTIM.ITT_AVAILABILITY]) ===
                VICTIM_ITT_AVAILABILITY.AVAILABLE ||
                (!isNil(get(victim, [VICTIM.ITT], null)) &&
                  get(victim, [VICTIM.ITT]) !== '')) && (
                <TextField
                  label={translate({ ...messages.ITT }, props)}
                  className="input"
                  type="number"
                  name={VICTIM.ITT}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                  value={parseInt(get(victim, [VICTIM.ITT]))}
                  onChange={handleChange(VICTIM.ITT)}
                  error={!!get(victimValidation, [VICTIM.ITT])}
                  helperText={message[VICTIM.ITT]}
                ></TextField>
              )}
            </>
          )}
        <FormControl
          className="input"
          error={!!get(victimValidation, [VICTIM.OPPOSITION])}
        >
          <InputLabel
            ref={inputLabel}
            id="simple-select-outlined-label-work-accident"
          >
            {translate({ ...messages.victimOpposition }, props)}
          </InputLabel>
          <Select
            name={VICTIM.OPPOSITION}
            value={
              get(victim, [VICTIM.OPPOSITION], '') === false
                ? 0
                : get(victim, [VICTIM.OPPOSITION], '') === true
                ? 1
                : ''
            }
            onChange={handleChange(VICTIM.OPPOSITION)}
            labelWidth={140}
          >
            <MenuItem value={0}>
              {translate({ ...messages.claimDeclarationNo }, props)}
            </MenuItem>
            <MenuItem value={1}>
              {translate({ ...messages.claimDeclarationYes }, props)}
            </MenuItem>
          </Select>
          {!!get(victimValidation, [VICTIM.OPPOSITION]) && (
            <FormHelperText className="errorSelect">
              {message[VICTIM.OPPOSITION]}
            </FormHelperText>
          )}
        </FormControl>
        <Autocomplete
          id="city_complete_1"
          className="input"
          options={getMoroccanCities(get(props.listings, 'villes', [])) || []}
          getOptionLabel={city => city?.ItemDescription || ''}
          autoSelect={true}
          onChange={handleChange(VICTIM.CITY)}
          value={
            getCity(
              get(props.listings, 'villes', []),
              String(get(victim, [VICTIM.CITY], '')),
            ) || ({} as any)
          }
          filterOptions={filterOptions}
          renderInput={params => (
            <TextField
              {...params}
              value={String(get(victim, [VICTIM.CITY], ''))}
              name={VICTIM.CITY}
              label={translate({ ...messages.victimCity }, props)}
              error={!!get(victimValidation, [VICTIM.CITY])}
              helperText={message[VICTIM.CITY]}
            />
          )}
        />
        <TextField
          label={translate({ ...messages.adress }, props)}
          className="input"
          name={VICTIM.ADDRESS}
          value={get(victim, [VICTIM.ADDRESS])}
          onChange={handleChange(VICTIM.ADDRESS)}
          error={!!get(victimValidation, [VICTIM.ADDRESS])}
          helperText={message[VICTIM.ADDRESS]}
        ></TextField>
        {!INJURY_POST.INJURED.includes(
          get(victim, [VICTIM.INJURY_POST_KEY], ''),
        ) && (
          <>
            <TextField
              type="number"
              label={translate({ ...messages.numberOfPartners }, props)}
              className="input"
              name={VICTIM.NUMBER_OF_SPOUSE}
              value={get(victim, [VICTIM.NUMBER_OF_SPOUSE])}
              onChange={handleChange(VICTIM.NUMBER_OF_SPOUSE)}
              error={!!get(victimValidation, [VICTIM.NUMBER_OF_SPOUSE])}
              helperText={message[VICTIM.NUMBER_OF_SPOUSE]}
              disabled={get(victim, [VICTIM.CLASS_KEY]) === MINOR_VALUE}
            />
            <TextField
              label={translate({ ...messages.numberOfChildren }, props)}
              type="number"
              className="input"
              name={VICTIM.NUMBER_OF_CHILDREN}
              value={get(victim, [VICTIM.NUMBER_OF_CHILDREN])}
              onChange={handleChange(VICTIM.NUMBER_OF_CHILDREN)}
              error={!!get(victimValidation, [VICTIM.NUMBER_OF_CHILDREN])}
              helperText={message[VICTIM.NUMBER_OF_CHILDREN]}
              disabled={get(victim, [VICTIM.CLASS_KEY]) === MINOR_VALUE}
            />
            <TextField
              type="number"
              label={translate({ ...messages.numberOfDependents }, props)}
              className="input"
              name={VICTIM.NUMBER_OF_DEPENDENTS}
              value={get(victim, [VICTIM.NUMBER_OF_DEPENDENTS])}
              onChange={handleChange(VICTIM.NUMBER_OF_DEPENDENTS)}
              error={!!get(victimValidation, [VICTIM.NUMBER_OF_DEPENDENTS])}
              helperText={message[VICTIM.NUMBER_OF_DEPENDENTS]}
              disabled={get(victim, [VICTIM.CLASS_KEY]) === MINOR_VALUE}
            />
            <TextField
              label={translate({ ...messages.annualOfIncome }, props)}
              className="input"
              type="number"
              name={VICTIM.ANNUAL_INCOME}
              value={get(victim, [VICTIM.ANNUAL_INCOME])}
              onChange={handleChange(VICTIM.ANNUAL_INCOME)}
              error={!!get(victimValidation, [VICTIM.ANNUAL_INCOME])}
              helperText={message[VICTIM.ANNUAL_INCOME]}
            />
          </>
        )}

        <Typography className="text">
          {translate({ ...messages.excludeVictim }, props)}
        </Typography>
        <div>
          <FormControl>
            <RadioGroup
              value={get(victim, [VICTIM.IS_EXCLUDED])}
              onChange={handleChange(VICTIM.IS_EXCLUDED)}
              row
            >
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    value={CHOICES.YES}
                    checkedIcon={<CheckCircle />}
                  />
                }
                label={translate({ ...messages.yes }, props)}
              />
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    value={CHOICES.NO}
                    checkedIcon={<CheckCircle />}
                  />
                }
                label={translate({ ...messages.no }, props)}
              />
            </RadioGroup>
            {!!get(victimValidation, [VICTIM.IS_EXCLUDED]) && (
              <FormHelperText className="error">
                {message[VICTIM.IS_EXCLUDED]}
              </FormHelperText>
            )}
          </FormControl>
        </div>

        {INJURY_POST.DECEASED.includes(
          get(victim, [VICTIM.INJURY_POST_KEY], ''),
        ) && (
          <>
            <Typography className="subTitle">
              {translate({ ...messages.vitimDeceasedTitle }, props)}
            </Typography>
            {get(victim, 'beneficiaries', []) &&
              get(victim, 'beneficiaries', []).map(
                (beneficiary: BeneficiaryType, beneficiary_index: number) => (
                  <div key={beneficiary_index} style={{ marginBottom: 10 }}>
                    <Typography className="titleAccordion">
                      {translate(
                        { ...messages.beneficiaryAccordionTitle },
                        props,
                        { number: beneficiary_index },
                      )}
                    </Typography>
                    <BeneficiaryForm
                      isDrawer={true}
                      isDrawerAdd={true}
                      listing={props.listings}
                      withoutPadding={true}
                      couldDelete={false}
                      beneficiary={beneficiary}
                      handleSubmit={() => {}}
                      handleDelete={() => {}}
                      handleChangeBeneficiaryTransaction={(
                        payload: BeneficiaryType,
                      ) =>
                        setBeneficiaries(
                          (updateItemInList(
                            get(victim, 'beneficiaries', []),
                            item => item.id === beneficiary.id,
                            payload,
                          ) as unknown) as BeneficiaryType[],
                        )
                      }
                      inputProps={{}}
                      disableInput={false}
                      handleCancel={() => {}}
                      victim={victim}
                      beneficiaryToUpdate={beneficiary}
                      lossDate={get(props.data, 'claim.lossDate')}
                    />
                  </div>
                ),
              )}
          </>
        )}
        {isMinorVictim(victim, get(props.data, 'claim.lossDate')) && (
          <>
            <Typography className="subTitle">
              {translate({ ...messages.tutor }, props)}
            </Typography>
            <TextField
              label={translate({ ...messages.victimCin }, props)}
              className="input"
              name={TUTOR.CIN}
              value={get(tutorInfo, [TUTOR.CIN])}
              onChange={handleChangeTutorInfo(TUTOR.CIN)}
              InputProps={{ inputProps: { maxlength: 20 } }}
            />
            <TextField
              label={translate({ ...messages.victimLastName }, props)}
              className="input"
              name={TUTOR.LAST_NAME}
              value={get(tutorInfo, [TUTOR.LAST_NAME])}
              onChange={handleChangeTutorInfo(TUTOR.LAST_NAME)}
            />
            <TextField
              label={translate({ ...messages.victimFirstName }, props)}
              className="input"
              name={TUTOR.FIRST_NAME}
              value={get(tutorInfo, [TUTOR.FIRST_NAME])}
              onChange={handleChangeTutorInfo(TUTOR.FIRST_NAME)}
            />
          </>
        )}

        <>
          <Typography className="subTitle">
            {translate({ ...messages.claimCircumstancesTitle }, props)}
          </Typography>
          <GridWrapper>
            {get(scaleInfo, ['managementModeKey']) ===
              MANAGEMENT_MODES.COMMON_RIGHT ||
            get(scaleInfo, ['managementModeKey']) ===
              MANAGEMENT_MODES.FOREIGN ? (
              <FormControl className="input" fullWidth>
                <InputLabel ref={inputLabel} id="scaleCase" className="label">
                  {translate({ ...messages.scaleCase }, props)}
                </InputLabel>
                <Select
                  name={CLAIM.SCALE_CASE_KEY}
                  value={get(scaleInfo, [CLAIM.SCALE_CASE_KEY], '')}
                  onChange={handleChangeScaleCase(CLAIM.SCALE_CASE_KEY)}
                  disabled={false}
                >
                  {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                    get(props.listings, 'casDeBareme', []).map(
                      (scaleCase: SagisConfig) => (
                        <MenuItem
                          value={scaleCase.ItemKey}
                          key={scaleCase.ItemKey}
                        >
                          {scaleCase.ItemDescription}
                        </MenuItem>
                      ),
                    )}
                </Select>
              </FormControl>
            ) : (
              <FormControl fullWidth>
                <InputLabel ref={inputLabel} id="scaleCase" className="label">
                  {translate({ ...messages.scaleCase }, props)}
                </InputLabel>
                <Select
                  name={CLAIM.SCALE_CASE_KEY}
                  value={get(scaleInfo, [CLAIM.SCALE_CASE_KEY], '')}
                  onChange={handleChangeScaleCase(CLAIM.SCALE_CASE_KEY)}
                  disabled={false}
                  error={
                    get(message, [CLAIM.SCALE_CASE_KEY]) &&
                    get(claimCircumstancesValidation, [CLAIM.SCALE_CASE_KEY])
                  }
                >
                  {!isEmpty(get(props.listings, 'casDeBareme', [])) &&
                    get(props.listings, 'casDeBareme', []).map(
                      (scaleCase: SagisConfig) => (
                        <MenuItem
                          value={scaleCase.ItemKey}
                          key={scaleCase.ItemKey}
                        >
                          {scaleCase.ItemDescription}
                        </MenuItem>
                      ),
                    )}
                </Select>
                {get(message, [CLAIM.SCALE_CASE_KEY]) &&
                  get(claimCircumstancesValidation, [CLAIM.SCALE_CASE_KEY]) && (
                    <FormHelperText className="errorSelect">
                      {message[CLAIM.SCALE_CASE_KEY]}
                    </FormHelperText>
                  )}
              </FormControl>
            )}
            {get(scaleInfo, [CLAIM.SCALE_CASE_KEY]) && (
              <FormControl className="input" fullWidth>
                <InputLabel
                  ref={inputLabel}
                  id="circumstanceCode"
                  className="label"
                >
                  {translate({ ...messages.circumstance }, props)}
                </InputLabel>
                <Select
                  name={CLAIM.ACCIDENT_CIRCONSTANCE_KEY}
                  value={get(scaleInfo, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY], '')}
                  onChange={handleChangeScaleCase(
                    CLAIM.ACCIDENT_CIRCONSTANCE_KEY,
                  )}
                  disabled={false}
                  error={
                    get(message, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) &&
                    get(claimCircumstancesValidation, [
                      CLAIM.ACCIDENT_CIRCONSTANCE_KEY,
                    ])
                  }
                >
                  {!isEmpty(getCircumstances()) &&
                    getCircumstances().map((circumstance: SagisConfig) => (
                      <MenuItem
                        value={circumstance.ItemKey}
                        key={circumstance.ItemKey}
                      >
                        {circumstance.ItemDescription}
                      </MenuItem>
                    ))}
                </Select>
                {get(message, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) &&
                  get(claimCircumstancesValidation, [
                    CLAIM.ACCIDENT_CIRCONSTANCE_KEY,
                  ]) && (
                    <FormHelperText className="errorSelect">
                      {message[CLAIM.ACCIDENT_CIRCONSTANCE_KEY]}
                    </FormHelperText>
                  )}
              </FormControl>
            )}
            {(isScaleCaseOther ||
              (!isEmpty(get(scaleInfo, [CLAIM.ACCIDENT_CIRCONSTANCE])) &&
                get(scaleInfo, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]))) && (
              <TextField
                onChange={handleChangeScaleCase(CLAIM.ACCIDENT_CIRCONSTANCE)}
                name={CLAIM.ACCIDENT_CIRCONSTANCE}
                value={get(scaleInfo, [CLAIM.ACCIDENT_CIRCONSTANCE])}
                label={translate({ ...messages.circumstanceDetail }, props)}
                fullWidth
                multiline
                disabled={false}
                error={
                  !!get(claimCircumstancesValidation, [
                    CLAIM.ACCIDENT_CIRCONSTANCE,
                  ])
                }
                helperText={message[CLAIM.ACCIDENT_CIRCONSTANCE]}
              />
            )}
            {get(scaleInfo, [CLAIM.ACCIDENT_CIRCONSTANCE_KEY]) && (
              <FormControl className="input" fullWidth>
                <InputLabel
                  ref={inputLabel}
                  id="responsibility"
                  className="label"
                >
                  {translate({ ...messages.responsibility }, props)}
                </InputLabel>
                <Select
                  name={CLAIM.RESPONSABILITY_KEY}
                  value={get(scaleInfo, [CLAIM.RESPONSABILITY_KEY], '')}
                  onChange={handleChangeScaleCase(CLAIM.RESPONSABILITY_KEY)}
                  disabled={!isScaleCaseOther}
                  error={
                    get(message, [CLAIM.RESPONSABILITY_KEY]) &&
                    get(claimCircumstancesValidation, [
                      CLAIM.RESPONSABILITY_KEY,
                    ])
                  }
                >
                  {!isEmpty(get(props.listings, 'responsability', [])) &&
                    get(props.listings, 'responsability', []).map(
                      (responsability: SagisConfig) => (
                        <MenuItem
                          value={responsability.ItemKey}
                          key={responsability.ItemKey}
                        >
                          {responsability.ItemDescription}
                        </MenuItem>
                      ),
                    )}
                </Select>
                {get(message, [CLAIM.RESPONSABILITY_KEY]) &&
                  get(claimCircumstancesValidation, [
                    CLAIM.RESPONSABILITY_KEY,
                  ]) && (
                    <FormHelperText className="errorSelect">
                      {message[CLAIM.RESPONSABILITY_KEY]}
                    </FormHelperText>
                  )}
              </FormControl>
            )}
            {get(scaleInfo, [CLAIM.RESPONSABILITY_KEY]) && (
              <TextField
                id="standard-basic-desc"
                onChange={handleChangeScaleCase(CLAIM.ACCIDENT_DESCRIPTION)}
                name={CLAIM.ACCIDENT_DESCRIPTION}
                value={get(scaleInfo, [CLAIM.ACCIDENT_DESCRIPTION])}
                label={translate({ ...messages.description }, props)}
                fullWidth
                disabled={false}
                InputLabelProps={{ shrink: props.inputLabelProps }}
                multiline
                error={
                  !!get(claimCircumstancesValidation, [
                    CLAIM.ACCIDENT_DESCRIPTION,
                  ])
                }
                helperText={message[CLAIM.ACCIDENT_DESCRIPTION]}
              />
            )}
          </GridWrapper>

          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              autoOk
              disableFuture
              variant="inline"
              invalidDateMessage=""
              format="dd/MM/yyyy"
              id="receptionDate"
              onChange={handleChangeDate}
              name={'RECEPTION_DATE'}
              value={dateStringToLocalDate(receptionDate as any)}
              label={translate({ ...messages.receptionDate }, props)}
              style={{ width: '100%', marginBottom: 10 }}
              InputLabelProps={{
                shrink: !!receptionDate,
                classes: { root: 'label-input' },
              }}
              error={
                new Date(receptionDate as any) > new Date() ||
                receptionDate === ('' as any) ||
                receptionDate === null ||
                moment(receptionDate).format(DATE_FORMAT) === 'Invalid date' ||
                receptionDate === ('Invalid Date' as any)
              }
              helperText={
                new Date(receptionDate as any) > new Date() ||
                receptionDate === ('' as any) ||
                receptionDate === null ||
                moment(receptionDate).format(DATE_FORMAT) === 'Invalid date' ||
                receptionDate === ('Invalid Date' as any)
                  ? translate(messages.invalidDate, props)
                  : ''
              }
            />
          </MuiPickersUtilsProvider>
        </>

        <Typography className="subTitle">
          {translate({ ...messages.documentsTitle }, props)}
        </Typography>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={10}>
            <FormControl
              style={{
                width: '90%',
              }}
            >
              <InputLabel
                ref={inputLabel}
                className="input"
                id="simple-select-outlined-label-procedure"
              >
                {translate(
                  { ...messages.transactionUploadDocumentTitle },
                  props,
                )}
              </InputLabel>
              <Select
                name={'docType'}
                value={documentType}
                onChange={handleChangeDocumentType}
                labelWidth={230}
              >
                {!isEmpty(
                  get(props.listings, 'transactionDocumentTypes', []),
                ) &&
                  filterVisibleOnly(
                    get(props.listings, 'transactionDocumentTypes', []),
                  ).map(item => (
                    <MenuItem value={item.title} key={item.title}>
                      {item.title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <div
              style={{ marginTop: '20px' }}
              onClick={() => addTransactionDocument(documentType)}
            >
              <AddCircleOutline />
            </div>
          </Grid>
        </Grid>

        {!isEmpty(transactionDocuments) &&
          transactionDocuments.map((el: any, index: number) => (
            <div style={{ marginTop: 20 }}>
              <UploadDocument
                index={index}
                name={formatTitleDocument(index)}
                type={el?.type}
                setDocumentState={handleChangeDocument(
                  formatTitleDocument(index),
                )}
                documentState={transactionDocuments}
                handleDeleteDocument={handleDeleteDocument}
              />
            </div>
          ))}
        {getDocumentWithoutType(transactionDocuments) && (
          <FormHelperText className="errorSelect">
            {translate({ ...messages.documentTypeError }, props)}
          </FormHelperText>
        )}
        {(documentType === DOCUMENT_TYPES.INCOME_CERTIFICATE ||
          !isEmpty(
            getDocumentsByType(
              transactionDocuments,
              DOCUMENT_TYPES.INCOME_CERTIFICATE,
            ),
          ) ||
          documentType === DOCUMENT_TYPES.SCHOOLING_CERTIFICATE ||
          !isEmpty(
            getDocumentsByType(
              transactionDocuments,
              DOCUMENT_TYPES.SCHOOLING_CERTIFICATE,
            ),
          )) && (
          <TextField
            label={translate({ ...messages.income }, props)}
            name={INCOME_CERTIFICATE.INCOME}
            value={income}
            onChange={handleChangeIncome}
            type="number"
            style={{ marginTop: 20 }}
            InputLabelProps={{
              shrink: !isNil(income),
            }}
            error={get(message, INCOME_CERTIFICATE.INCOME)}
            helperText={get(message, INCOME_CERTIFICATE.INCOME)}
          />
        )}
      </Container>
    </SahamDrawer>
  );
};

export default injectIntl(AddTransactionDrawer);
